import { AbiFunction } from 'ox';
import { htlcFunctions } from '../../abi.js';
import { decodeContractError, hex } from '../../utils.js';
export async function redeemSolver(rpc, signer, params) {
    const { id, contractAddress, secret, destinationAddress } = params;
    const caller = destinationAddress ?? signer.address;
    const calldata = AbiFunction.encodeData(htlcFunctions.redeemSolver, [
        hex(id),
        1n,
        BigInt(secret),
    ]);
    try {
        await rpc.ethCall(contractAddress, calldata, caller);
        return signer.sendTransaction({ to: contractAddress, data: calldata });
    }
    catch (error) {
        const errorName = decodeContractError(error);
        if (errorName)
            throw new Error(`Contract error: ${errorName}`);
        console.error('Error in redeemSolver:', error);
        throw error;
    }
}
